import { growthbookIntegration } from '@sentry/core';

/**
 * Re-export the core GrowthBook integration for Node.js usage.
 * The core integration is runtime-agnostic and works in both browser and Node environments.
 */
const growthbookIntegrationShim = growthbookIntegration;

export { growthbookIntegrationShim };
//# sourceMappingURL=growthbook.js.map
